export var UpdateStatus;
(function (UpdateStatus) {
    UpdateStatus["Mandatory"] = "mandatory";
    UpdateStatus["Flexible"] = "flexible";
    UpdateStatus["Optional"] = "optional";
    UpdateStatus["Error"] = "error";
    UpdateStatus["Unnecessary"] = "unnecessary";
})(UpdateStatus || (UpdateStatus = {}));
//# sourceMappingURL=definitions.js.map